import { ReferralQuestionKind } from '../refferals/refferals.enums';

export interface ReferralsPortalApplicationPayloadI {
  cv?: string;
  email: string;
  name: string;
  offerId: number;
  phone?: string;
  referralConnectionId?: number;
  referralQuestionAnswers?: ReferralQuestionAnswer[];
  socialLinks: string[];
}

export interface ReferralQuestionAnswer {
  questionTitle: string;
  questionKind: ReferralQuestionKind;
  questionPosition: number;
  questionRequired: boolean;
  questionOptions: { title: string; position?: string }[];
  content?: string;
  contents?: string[];
}

export enum ReferralsPortalApplicationStatus {
  Referred = 'referred',
  InReview = 'in_review',
  ProcessComplete = 'process_complete',
  Success = 'success',
}

export interface ReferralsPortalApplication {
  id: number;
  name: string;
  status: ReferralsPortalApplicationStatus;
  rewardName: string;
  referralConnectionId: number;
  photoThumbUrl: string;
  offerTitle: string;
  createdAt: string;
}
